import React, { useEffect, useState } from "react";
import ScreenPagination from "../../Component/ScreenPagination/ScreenPagination";
import DateRange from "../../Component/DateRange/DateRange";
import { Toast } from "../../Component/Toast";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment/moment";
import useStore from "../../LocalStore/useStore";
import CustomScroll from "../../Component/CustomScroll";

const DailyResult = () => {

  const { kv, set } = useStore();
  const dailyResult = kv.dailyresult || [];

  const [date, setDate] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [data, setData] = useState(dailyResult);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [inputValue, setInputValue] = useState(
    pageNumber.toString().padStart(2, "0")
  );
  const [displayDate, setDisplayDate] = useState("");



  const getList = async (date_) => {
    try {
      setDisplayDate(date_);
      let url_ = `?page=${pageNumber}`;
      if (date_) {
        url_ = url_ + `&date=${moment(date_).format("YYYY-MM-DD")}`;
      }
      const res = await get(`${URLS.DAILYRESULTS}` + url_);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setData(res?.data);
        set("dailyresult", res?.data);
        setTotalPages(res?.pagination?.total_pages || 1);
      } else {
        setData([]);
        setTotalPages(1);
      }
    } catch (err) {
      Toast("Failed to load history");
    }
  };

  useEffect(() => {
    getList();
  }, [pageNumber]);

  return (
    <div style={{ marginBottom: 20, paddingBottom: 45 }} className="dashRightViews bd-3">
      <CustomScroll >
        <div className=" p-3 pb-5 mb-4">
          <DateRange
            fromDate={displayDate}
            onChange={(dates) => getList(dates)}
          />
          {data?.map((item) => {
            return (
              <div className="calender-input-daily mt-4 p-3">
                <div className="d-flex ae-jb">
                  <p className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-16 ">
                    {" "}
                    Date{" "}
                  </p>
                  <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-16 gray">
                    {item?.date}{" "}
                  </p>
                </div>
                <div className="d-flex ae-jb mt-2">
                  <p className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-16 ">
                    {" "}
                    Lot Name{" "}
                  </p>
                  <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-16 gray">
                    {item?.lot_name
                      ? item.lot_name.charAt(0).toUpperCase() + item.lot_name.slice(1).toLowerCase()
                      : "Dear"}
                  </p>
                </div>
                <div className="d-flex ae-jb mt-2">
                  <p className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-16 ">
                    {" "}
                    Time{" "}
                  </p>
                  <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-16 gray">
                    {item?.time}
                  </p>
                </div>
                <div className="d-flex ae-jb mt-2">
                  <p className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-16 ">
                    {" "}
                    Result Number{" "}
                  </p>
                  <div style={{ color: '#000' }} className="d-flex ac-js gap-2">
                    {item?.winning_number &&
                      String(item?.winning_number)
                        .split("")
                        .map((num, index) => (
                          <p
                            style={{ color: '#fff' }}
                            className="f3 fs-xs-13 fs-sm-16 fs-md-16 fs-lg-16 res-num"
                            key={index}
                          >
                            {num}
                          </p>
                        ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CustomScroll>
      <ScreenPagination
        pagenumber={pageNumber}
        setPagenumber={setPageNumber}
        totalPages={totalPages}
      />
    </div>
  );
};

export default DailyResult;
